/** Shared MUI theme constants — keep in sync with `src/scss/index.scss`. */

export const FONT_BASE = '0.75rem'
export const FONT_MAX = '0.876rem'
export const LINE_HEIGHT_BASE = 1.45
export const LINE_HEIGHT_HEADING = 1.4

/** Non-pure-black ink tones, aligned to `--app-text-*` CSS vars. */
export const INK = {
  primary: '#272727',
  secondary: '#424242',
  disabled: 'rgba(66, 66, 66, 0.6)',
}
